import { render, staticRenderFns } from "./BasicInfoConsultarBpr.vue?vue&type=template&id=bdfc7bb2&"
import script from "./BasicInfoConsultarBpr.vue?vue&type=script&lang=js&"
export * from "./BasicInfoConsultarBpr.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfoConsultarBpr.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAlert,VCol,VDatePicker,VForm,VMenu,VRow,VTextField,VTextarea})
